/**
 * Route for `affiliate-manager`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AffiliateManagerPage } from "../features/affiliate-manager/AffiliateManagerPage";

export const affiliateManagerRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/affiliate-manager",
	component: AffiliateManagerPage,
});

export default affiliateManagerRoute;
